// extracted by mini-css-extract-plugin
module.exports = {"label":"CreateOrEditApiKeyPage_label__YD_8T"};